import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  background: white;
  border-top: 1px solid ${(props) => props.theme.colors.grayBorder};
  margin-top: auto;
  position: absolute;
  bottom: 73px;
`;

export const TopRow = styled.div`
  padding: 12px 24px;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;

  & svg {
    height: 14px;
    width: 14px;

    & path {
      fill: ${(props) => props.theme.colors.dark};
    }
  }
`;

export const Label = styled.p`
  font-size: 14px;
  font-weight: 500;
  color: ${(props) => props.theme.colors.dark};
  display: flex;
  align-items: center;

  & svg {
    height: 16px;
    fill: ${(props) => props.theme.colors.darkGray};
    margin-left: 5px;
  }
`;

export const Content = styled.div`
  padding: 0 24px 12px;
`;

export const CheckboxRow = styled.div`
  display: flex;
  align-items: center;
`;

export const Languages = styled.div`
  margin-top: 8px;
  padding-left: 24px;
`;

interface IProps {
  selected: boolean;
  disabled: boolean;
}

export const LanguageTag = styled.button<IProps>`
  height: 24px;
  line-height: 12px;
  padding: 4px 10px;
  font-size: 14px;
  font-weight: 400;
  color: ${(props) => (props.selected ? 'white' : '#979797')};
  background: ${(props) => {
    if (props.disabled && props.selected) {
      return props.theme.colors.darkGray;
    }
    if (props.selected) {
      return props.theme.colors.primary;
    }
    return props.theme.colors.lightGray;
  }};
  border-radius: 12px;
  border: 1px solid;
  border-color: ${(props) =>
    props.selected && !props.disabled ? props.theme.colors.primary : props.theme.colors.grayBorder};
  margin-right: 12px;
  margin-bottom: 8px;
  cursor: ${(props) => (props.disabled ? 'default' : 'pointer')};
`;

export const SelectButton = styled.button`
  margin-top: 4px;
  margin-left: 24px;
  font-size: 14px;
  font-weight: 500;
  border: none;
  outline: none;
  cursor: pointer;
  color: ${(props) => props.theme.colors.primary};
  background: none;
`;
